import { render, staticRenderFns } from "./power-curve.vue?vue&type=template&id=ae8dd5ba&scoped=true&"
import script from "./power-curve.vue?vue&type=script&lang=js&"
export * from "./power-curve.vue?vue&type=script&lang=js&"
import style0 from "./power-curve.vue?vue&type=style&index=0&id=ae8dd5ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8dd5ba",
  null
  
)

export default component.exports